import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {Statistic} from '../interfaces/statistic';
import {API_URLS} from '../config';
import {catchError} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {StatisticRow} from "../interfaces/statistic-row";
import {GetStatisticRequestArgs} from "../interfaces/get-statistic-request-args";

@Injectable({
  providedIn: 'root'
})
export class StatisticService {

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
  ) {}

  getStatistic(): Observable<Statistic | null> {
    return this.http.get<Statistic>(API_URLS.getStatistic)
      .pipe(
        catchError(() => of(null)),
      );
  }

  getTrafficDetail(args: any): Observable<any> {
    return this.http.post<any>(API_URLS.getTrafficDetail, args)
      .pipe(
        catchError((error: HttpErrorResponse) => {
            if (error && error.status && error.status !== 200) {
              let summaryString = 'Произошла ошибка.';
              if (error.error?.exception === 'ClickHouseDB\\Exception\\QueryException') {
                summaryString = 'Произошла ошибка при поиске потребленного трафика.';
              } else if (error.error?.exception === 'ErrorException') {
                summaryString = 'Произошла ошибка при поиске сессии.';
              }
              this.messageService.add({
                severity: 'error',
                summary: summaryString,
                detail: 'Сервис недоступен в данный момент. Пожалуйста, обратитесь в техническую поддержку.',
                life: 10 * 1000
              });
            }
          return of(null);
          }
        )
      );
  }

  getStatisticsByMonths(args: GetStatisticRequestArgs): Observable<StatisticRow[]> {
    return this.http.post<StatisticRow[]>('/api/get_statistic_by_months', args);
  }

  getStatisticsByDays(args: GetStatisticRequestArgs): Observable<StatisticRow[]> {
    return this.http.post<StatisticRow[]>('/api/get_statistic_by_days', args);
  }

  getStatisticsByHours(args: GetStatisticRequestArgs): Observable<StatisticRow[]> {
    return this.http.post<StatisticRow[]>('/api/get_statistic_by_hours', args);
  }
}
